import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

const latest = [...movies]
  .sort((a, b) => b.year - a.year || b.popularity - a.popularity)
  .slice(0, 8);

export default function LatestMovies() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 font-label text-[12px] uppercase tracking-[0.24em] text-primary-600">
              <span className="inline-block h-[1px] w-6 bg-accent-500"></span>
              新近收录
            </p>
            <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
              最近整理的八十年代影片
            </h2>
            <p className="mt-2.5 max-w-xl text-sm leading-relaxed text-foreground-600">
              每一部都附有完整资料、剧情概要与编辑影评摘录，方便你快速判断是否值得加入片单。
            </p>
          </div>
          <Link
            to="/category"
            className="inline-flex shrink-0 items-center gap-1.5 self-start rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 md:self-auto"
          >
            查看全部影片
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="mt-9 grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 md:gap-x-5 lg:grid-cols-4">
          {latest.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}